module.exports = __webpack_public_path__ + "img/spo2.08faff77.png";